<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="display-1">
          Sign-Up To Receive Notice Of Streaming Broadcasts
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="">
        <mailchimp-signup-form></mailchimp-signup-form>
      </v-col>
    </v-row>

    <v-divider style="width: 75%;" class="mx-auto my-7"></v-divider>
    
    <v-row>
      <v-col cols="12" md="6" class="text-center">
        <h2>About Us</h2>
        <p class="mx-auto">
          TeamHive.live is the new home for live-streaming events from local high schools.
          We have developed a brand new streaming platform to connect your local high school to the community.
        </p>
      </v-col>
      <v-col cols="12" md="6" class="text-center">
        <h2>Contact Us</h2>
        <p class="d-flex align-center justify-center">
          <v-icon class="mr-3" small>mdi-email</v-icon>
          <a href="mailto:info@teamhive.live">info@teamhive.live</a>
        </p>
      </v-col>
    </v-row>

    <v-divider style="width: 75%;" class="mx-auto my-7"></v-divider>

  </v-container>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data: () => ({}),
  computed: {
    ...mapState(['window']),
  },
};
</script>
<style scoped>
iframe {
  width: 100%;
}
</style>
